<div class="ticket-detail">
    <!-- Loading -->
    @if (loading) {
        <div class="detail-status">
            <div class="sw-spinner"></div>
            <span>Loading...</span>
        </div>
    }

    <!-- Error -->
    @if (error && !loading) {
        <div class="detail-status detail-error">
            <p>{{ error }}</p>
            <button class="sw-btn sw-btn-outline" (click)="loadTicket()">Retry</button>
        </div>
    }

    <!-- Ticket detail -->
    @if (ticket && !loading) {
        <div class="detail-header">
            <h3 class="detail-summary">{{ getFieldValue('summary') || ticket.summary }}</h3>
            <div class="detail-meta">
                <span class="detail-status-badge">{{ ticket.currentStatus?.status || 'Unknown' }}</span>
                <span class="detail-date">{{ ticket.createdDate?.friendly || ticket.createdDate }}</span>
            </div>
        </div>
        <div class="detail-description">{{ getFieldValue('description') }}</div>
        <!-- Comments -->
        <div class="detail-comments">
            <div class="detail-section-title">Activity</div>
            @if (comments.length === 0) {
                <div class="detail-no-comments">No comments yet.</div>
            }
            @for (comment of comments; track comment) {
                <div class="comment-item">
                    <div class="comment-header">
                        <span class="comment-author">{{ comment.author?.displayName || 'Unknown' }}</span>
                        <span class="comment-date">{{ comment.created?.friendly || comment.created }}</span>
                    </div>
                    <div class="comment-body">{{ comment.body }}</div>
                </div>
            }
        </div>
        <!-- Add comment -->
        <div class="detail-add-comment">
            <textarea class="sw-textarea" placeholder="Add a comment..." [(ngModel)]="newComment" [disabled]="submittingComment" rows="3"></textarea>
            <button class="sw-btn sw-btn-primary sw-btn-sm" (click)="addComment()" [disabled]="!newComment.trim() || submittingComment">
                {{ submittingComment ? 'Sending...' : 'Send' }}
            </button>
        </div>
    }
</div>
